import { useState } from 'react';
import PositionConstants from '../../constants/positions';
import ProtectedAdminRoute from '../../components/ProtectedAdminRoute';
import '../../styles/admin/AddMember.css';
import FileUpload from '../../components/FileUpload';
import { apiFetch } from '../../utils/api';

// Use PositionConstants.OPTIONS for position choices

export default function AddMember() {
  const [form, setForm] = useState({ name: '', position: [], image: '', linkedin: '' });
  const [message, setMessage] = useState('');
  
  const handleChange = e => {
    const { name, value, multiple, options } = e.target;
    if (multiple) {
      // For multi-select, build array of selected values
      const selected = Array.from(options).filter(opt => opt.selected).map(opt => opt.value);
      setForm(f => ({ ...f, [name]: selected }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = await apiFetch('/api/members', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });
    if (data && (data.success || data.ok || data._id)) {
      setMessage('Member added!');
      setForm({ name: '', position: [], image: '', linkedin: '' });
    } else {
      setMessage('Error adding member');
    }
  };

  return (
    <ProtectedAdminRoute>
      <div className="add-member-form">
      <h2>Add Team Member</h2>
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            id="name"
            name="name"
            placeholder="Full Name"
            value={form.name}
            onChange={handleChange}
            required
            autoComplete="off"
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="position">Position</label>
          <select
            id="position"
            name="position"
            value={form.position.length ? form.position : [PositionConstants.OPTIONS[0]]}
            onChange={handleChange}
            multiple
            required={form.position.length === 0}
            size={PositionConstants.OPTIONS.length}
            style={{ minHeight: `${PositionConstants.OPTIONS.length * 2}em`, fontSize: '1.1em' }}
          >
            {PositionConstants.OPTIONS.map(position => (
              <option key={position} value={position}>{position}</option>
            ))}
          </select>
        </div>
        
        <div className="form-group">
          <FileUpload
            label="Member Image (Optional)"
            currentUrl={form.image}
            onUpload={(url) => setForm({...form, image: url})}
            accept="image/*"
            showPreview={true}
          />
        </div>
        
        <div className="form-group">
          <label htmlFor="linkedin">LinkedIn URL (Optional)</label>
          <input
            id="linkedin"
            name="linkedin"
            placeholder="https://linkedin.com/in/username"
            value={form.linkedin}
            onChange={handleChange}
            type="url"
            autoComplete="off"
          />
        </div>
        
        <button type="submit">Add Member</button>
      </form>
      {message && <div className="message">{message}</div>}
    </div>
    </ProtectedAdminRoute>
  );
}